import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
	list({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/weekPlanWork/list`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getCreateInfo({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/weekPlanWork/getCreateInfo',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findOrgTreeByCurrentUser({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: 'weekPlanWork/findOrgTreeByCurrentUser'
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getWeekList({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get(`/weekPlanWork/getWeekList`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  generateWeekReport({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/weekPlanWork/generateWeekReport',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  sgetWeekPlanOrReportList({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/weekPlanWork/getWeekPlanOrReportList',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getSearchTitle({ commit }) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/weekPlanWork/getSearchTitle'
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getNoFinishList({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios.post('/weekPlanWork/getNoFinishList', data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  createNewPlan({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/weekPlanWork/createNewPlan',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/weekPlanWork/saveWeekInfo`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  saveWeekQuestion({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/weekPlanWork/saveWeekQuestion`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/weekPlanWork/findById',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  delete({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/weekPlanWork/delete',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
}
